import { getTextSize } from '../../../visualizations/common/getTextSize.js';
import { OneUxPlotChartTypographyToken } from '../types.js';
export const calculatePointLabelRect = (text: string, x: number, y: number, dx: number, dy: number, textAnchor: 'middle' | 'start' | 'end', dominantBaseline: 'auto' | 'middle' | 'hanging', typography: OneUxPlotChartTypographyToken): DOMRect => {
  const {
    width,
    fontHeight
  } = getTextSize(text, typography);

  /* unfortunately at this time it's not possible to calculate actual line-height */
  const estimatedLineHeight = fontHeight * 1.2;
  let textAnchorOffsetX = 0;
  switch (textAnchor) {
    case 'start':
      textAnchorOffsetX = 0;
      break;
    case 'middle':
      textAnchorOffsetX = -width / 2;
      break;
    case 'end':
      textAnchorOffsetX = -width;
      break;
  }
  let dominantBaselineOffsetY = 0;
  switch (dominantBaseline) {
    case 'auto':
      dominantBaselineOffsetY = -estimatedLineHeight / 1.5;
      break;
    case 'middle':
      dominantBaselineOffsetY = -estimatedLineHeight / 2;
      break;
    case 'hanging':
      dominantBaselineOffsetY = -1;
      break;
  }
  const left = x + dx + textAnchorOffsetX;
  const top = y + dy + dominantBaselineOffsetY;
  return new DOMRect(left, top, width, fontHeight);
};